import { h } from '@stencil/core';
import state from 'store';
import { i18n } from 'i18n';
import { triggerOpenNewLink } from 'utils/events';

export default function ViewMoreModal({ show }: { show: boolean }) {
  const onClose = () => {
    state.showFullScreenModal = null;
  };

  if (show) {
    setTimeout(() => {
      document.querySelectorAll('#view-more-modal .chat-faqs-markdown a')?.forEach(link => {
        link.addEventListener('click', event => {
          event.preventDefault();

          triggerOpenNewLink({
            newTab: true,
            href: link.getAttribute('href') ?? '',
          });
        });
      });
    }, 250);
  }

  return show ? (
    <div id="view-more-modal" role="presentation" class={'eva-3-modal -smooth-scroll fullscreen-modal -show-modal'}>
      <div class="modal-header" role="presentation">
        <div class="modal-title-container">
          <h4 class="eva-3-h4 modal-title">{state.viewMoreModal.title}</h4>
        </div>
        <i
          class="eva-3-icon-cross modal-close -eva-3-mr-md"
          role="button"
          tabindex="0"
          aria-label={i18n.t.chat.message.feedback.close}
          onClick={() => {
            onClose();
          }}
        ></i>
      </div>
      <div class="modal-content chat-faqs-markdown" role="presentation" innerHTML={state.viewMoreModal.body}></div>
    </div>
  ) : null;
}
